<template>
    <div class="membercentre">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item>
                <img :src="require('../assets/' + $t('lang.vip.bg1'))" class="swipe-img"/>
            </van-swipe-item>
            <van-swipe-item>
                <img :src="require('../assets/' + $t('lang.vip.bg2'))" class="swipe-img"/>
            </van-swipe-item>
            <van-swipe-item>
                <img :src="require('../assets/' + $t('lang.vip.bg3'))" class="swipe-img"/>
            </van-swipe-item>
        </van-swipe>
        <div class="package">
            <div class="title">
                <img src="../assets/left_icon.png" class="left-icon"/>
                <span>{{$t('lang.vip.title')}}</span>
                <img src="../assets/right_icon.png" class="right-icon"/>
            </div>
            <div class="type-wrapper">
                <div class="type-bg" v-for="(item, index) in goodsInfo" :key="index">
                    <div class="top-icon" :class="selectedIndex == index ? 'active-top-icon' : ''"
                        v-if="item.canUseDiscount">{{$t('lang.vip.discountTxt')}}</div>
                    <img class="unactive-shadow" src="../assets/unactive_shadow.png" v-show="!item.isSelected"/>
                    <img class="active-shadow" src="../assets/active_shadow.png" v-show="item.isSelected"/>
                    <div :class="item.isSelected ? 'type-bg-active' : 'type-bg-unactive'" @click="select(item, index)">
                         <div class="type">
                            <span class="left"></span>
                            <span>{{item.goodName}}</span>
                            <span class="right"></span>
                        </div>
                        <p class="price"><span class="symbol">{{$t('lang.vip.currency')}}</span>{{item.canUseDiscount?item.discountPrice/100:item.price/100}}</p>
                        <p class="original-price" :class="item.canUseDiscount?'discount-price':''">{{$t('lang.vip.currency')}}{{item.originalPrice/100}}/{{$t('lang.vip.unitI5')}}</p>
                    </div>
                   
                </div>
            </div>
            </van-grid>
            <div class="btn-wrapper">
                <div class="date" v-if="userInfo.status == 1">{{$t('lang.vip.expired1')}}{{userInfo.expiredDate}}{{$t('lang.vip.expired')}}</div>
                <button class="subs-btn" :class="userInfo.status == 1 ? 'subs-btn-vip': ''"
                    @click="subs">{{btnText}}</button>
            </div>
            <div class="tip" v-if="isiOS">
                {{$t('lang.vip.tip')}}<router-link to="/member"><span class="color_34A795">{{$t('lang.vip.memberBtn')}}</span></router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast, Button, Field, Swipe, SwipeItem, Grid, GridItem } from "vant";
import {closeAccount, accountTest, getShop, getVipInfo, postMember} from "@/api/api";
import wView from "@/utils/webSDK.js"
import common from "@/utils/common.js"
export default {
  data() {
    return {
      keyWords: "",
      border: false,
      submitActive: false,
      shopName: common.getQueryString('shopName'),
      goodsInfo: [],
      selectedIndex: 0,
      userInfo : {},
      btnText: '',
      isiOS: common.isiOS(),
      lang: common.getCookie('qz-lang')
    };
  },
  components: {
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Field.name]: Field,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
  },
  beforeMount: function() {
    this.init();
  },
  methods: {
    init() {
        let that = this

        getShop(that.shopName).then(res => {
            res.data.map(function(item, index){
                item.isSelected = false
                if(item.name.indexOf('月') > -1 || item.name.indexOf('Month') > -1){
                    if(that.isiOS){
                        item.goodName = that.$t('lang.vip.unitI1') + that.$t('lang.vip.unitI2')+ that.$t('lang.vip.unitI6')
                    }else{
                        item.goodName = '1' + that.$t('lang.vip.unitA')
                    }
                }
                if(item.name.indexOf('季') > -1 || item.name.indexOf('Season') > -1){
                    if(that.isiOS){
                        item.goodName = that.$t('lang.vip.unitI1') + that.$t('lang.vip.unitI3') + that.$t('lang.vip.unitI7')
                    }else{
                        item.goodName = '3' + that.$t('lang.vip.unitA')
                    }
                    item.originalPrice = item.originalPrice / 3
                }
                if(item.name.indexOf('年') > -1 || item.name.indexOf('Year') > -1){
                    if(that.isiOS){
                        item.goodName = that.$t('lang.vip.unitI1') + that.$t('lang.vip.unitI4') + that.$t('lang.vip.unitI8')
                    }else{
                        item.goodName = '12' + that.$t('lang.vip.unitA')
                    }
                    item.originalPrice = item.originalPrice / 12

                }
                return item
            })
            that.goodsInfo = res.data
            that.goodsInfo[0].isSelected = true
        })
        that.getVipInfo()
    },
    getVipInfo(){
        let that = this
        getVipInfo().then(res => {
            that.userInfo = res.data
            
            
            if(res.data.status == 1){ 
                if(that.isiOS){
                    that.btnText = that.$t('lang.vip.buyBtn2')
                }else{
                    that.btnText = that.$t('lang.vip.buyBtn3')
                }
            }else{
                if(that.isiOS){
                    that.btnText = that.$t('lang.vip.buyBtn1')
                }else{
                    that.btnText = that.$t('lang.vip.buyBtn3')
                }
            }
            if(that.userInfo.expireTime){
                that.userInfo.expiredDate = that.userInfo.expireTime.split('T')[0]
            }
        }) 
    },
    select(item, index){
        let that = this
        that.goodsInfo[index].isSelected = !that.goodsInfo[index].isSelected
        that.goodsInfo[that.selectedIndex].isSelected = !that.goodsInfo[that.selectedIndex].isSelected
        that.selectedIndex = index
    },
    handleTime(time){
        
    },
    subs(){
        let that = this
        let data = {
            "goodsId": that.goodsInfo[that.selectedIndex].goodsId,
            "amount": '1',
        }
        let payChannel = common.getQueryString('payChannel')
        if(payChannel ==='apple_iap'){
            payChannel = 'inApp'
        }else{
            payChannel = 'wxpay'
        }
        if(that.isiOS && that.userInfo.status == 1){

        }else{
            postMember(data).then(res => {
                if(res.hasOwnProperty('error')) {
                    Toast(res.error.message)
                    return
                }else{
                    wView.payOrder(payChannel, res.data.orderNo,function(response){
                        if(response.resultCode == 0){
                            wView.updateUser()
                            setTimeout(function(){
                                that.getVipInfo()
                            }, 500)
                        }else{
                            if (response.resultMessage) {
                                Toast(response.resultMessage)
                            }
                        }
                    })
                }
            })
        }
    },
    userNameFocus() {
      this.submitActive = true;
    },
    submit() {
      var that = this;
      if(that.keyWords != that.$t('lang.logout.keyWords')){
        Toast(that.$t('lang.logout.keyWordsAtten'));
      }else{
        closeAccount().then(res => {
          console.log(res)
          if(res.data.error){
              Toast(res.data.error.message);
          }else{
              Toast.success(that.$t('lang.logout.logoutSuccess'));
              this.setupWebViewJavascriptBridge(function(bridge) {
                  bridge.callHandler("closeaccount", {}, function(response) {});
              });
          }
        })
      }
    },
    setupWebViewJavascriptBridge: function(callback) {
      var that = this;
      if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
      } else if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      } else {
        document.addEventListener(
          "WebViewJavascriptBridgeReady",
          function() {
            callback(WebViewJavascriptBridge);
          },
          false
        );
      }
      window.WVJBCallbacks = [callback];
      var WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";
      var WVJBIframeSrc = that.isiOS
        ? "https://__bridge_loaded__"
        : "wvjbscheme://__BRIDGE_LOADED__";

      WVJBIframe.src = WVJBIframeSrc;
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function() {
        document.documentElement.removeChild(WVJBIframe);
      }, 0);
    },
  }
};
</script>
<style lang="less">
input::-webkit-input-placeholder {
  font-size: 14px;
  color: #999999;
}
.membercentre {
    .my-swipe{
        width: 375px!important;
        margin: 0 auto;
    }
    .van-swipe-item{
        width: 375px!important;
    }
    .van-swipe__indicators{
        bottom: 1.1rem!important;
    }
    .swipe-img{
        width: 375px;
        // height: 225px;
    }
    .package{
        width:343px;
        // height:464px;
        background:rgba(255,255,255,1);
        box-shadow:0px 6px 14px 0px rgba(24,22,42,0.14);
        border-radius:15px;
        margin: 0 auto;
        position: relative;
        top: -35px;
        .title{
            text-align: center;
            font-size:18px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(24,22,42,1);
            line-height:25px;
            padding: 34px 0 30px;
            img{
                height: 9px;
            }
            .left-icon{
                margin-right: 8px;
            }
            .right-icon{
                margin-left: 8px;
            }
        }
        .type-wrapper{
            position: relative;
            padding-left: 7px;
        }
        
        .type-bg{
            text-align: center;
            display: inline-block; 
            position: relative;  
            color:rgba(255,255,255,1); 
            .top-icon{
                width:43px;
                height:14px;
                background:rgba(255,137,137,1);
                border-radius:12px 0px 12px 0px;
                font-size:8px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                line-height:14px;
                position: absolute;
                left: 5px;
                top: 0px;
                z-index: 999;
            }
            .active-top-icon{
                top: -3px
            }   
            .type{
                font-size:12px;
                line-height:11px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 16px;
                .left{
                    margin-right: 4px;
                }
                .right{
                    margin-left: 4px;
                }
                .left, .right{
                    width:6px;
                    height:1px;
                    border-radius:1px;
                }
            }
            .price{
                width:100%;
                height:46px;
                font-size:30px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                line-height:46px;
                .symbol{
                    font-size: 15px;
                }
            }
            .original-price{
                font-size:14px;
                color:rgba(255,255,255,0.64);
                line-height:20px;
                padding-bottom: 15px;
            }
            .discount-price{
                text-decoration: line-through;
            }
        }
        .type-bg-unactive{
            width: 97px;
            height: 113px;
            background: url(../assets/unactive_bg.png) no-repeat 0% 0% / contain;
            margin: 0 5px;
            position: relative;
            z-index: 2;
        }
        .unactive-shadow{
            width: 130px;
            position: absolute;
            top: -5px;
            left: -10px;
            z-index: 1;
        }
        .type-bg-active{
            background: url(../assets/active_bg.png) no-repeat 0% 0% / contain;
            width: 103px;
            height: 119px;
            position: relative;
            bottom: 3px;
            margin: 0 5px;
            z-index: 2;
            color: #D86808;
            .type{
                padding-top: 19px;
            }
            .original-price{
                color:rgba(216,104,8,0.64);
            }
        }
        .active-shadow{
            position: absolute;
            top: -1px;
            left: -10px;
            width: 135px;
            z-index: 1;
        }
        .btn-wrapper{
            text-align: center;
            position: relative;
            .date{
                font-size:12px;
                color:rgba(239,184,93,1);
                line-height:16px;
                position: absolute;
                top: 41px;
                left: 124.5px;
            }
        }
        .subs-btn{
            width:311px;
            height:52px;
            background:linear-gradient(90deg,rgba(255,206,130,1) 0%,rgba(255,166,15,1) 100%);
            border-radius:52px;
            font-size:18px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(255,255,255,1);
            line-height:52px;
            margin: 62px 0 68px;
            border: none!important;
            opacity:1;
        }
        .subs-btn-vip{
            opacity:0.28;
        }
        .tip{
            width: 313px;
            text-align: justify;
            font-size:12px;
            color:rgba(140,139,151,1);
            line-height:17px;
            margin: 0 auto;
            padding-bottom: 24px;
            .color_34A795{
                color: #34A795;
                text-decoration: underline;
            }
        }        
    }
}
@media all and (min-height:300px) and (max-height:667px){
    .subs-btn{
        margin-bottom: 30px!important;
    }
}
</style>    

